import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify'
import Axios from '@/plugins/axios'

Vue.prototype.$http = Axios;
Vue.config.productionTip = true

Vue.prototype.$http.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response.status === 401) {
    store.commit('SET_LAYOUT', 'blank-layout')
    sessionStorage.removeItem('accessToken')
    router.push('/login')
  }

  return error;
});

Vue.prototype.$http.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('accessToken')
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  }, (error) => {
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
